import { type RoomType } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Center, Flex, Grid, Text } from "@chakra-ui/react";
import { CustomCenter } from "./roomFeed.style";

export const RoomFeed = ({ room }: { room: RoomType }) => {
    const { isMobile } = MEDIA();
    const { imgList } = { ...room };
    return (
        <Center as="section">
            <Flex
                maxW="1600px"
                w="100%"
                flexDir="column"
                p={isMobile ? "0 16px" : "0 48px"}
                gap={isMobile ? "10px" : "24px"}
            >
                <Flex
                    flexDir="column"
                    gap="8px"
                    sx={{
                        "& p": {
                            fontSize: "20px",
                            fontFamily: "Noto Serif KR",
                            fontWeight: "400",
                            lineHeight: "140%",
                            color: "#6b6b6b",
                        },
                    }}
                >
                    <Text>객실보기</Text>
                    <Text
                        color="#333 !important"
                        fontSize={isMobile ? "20px !important" : "26px !important"}
                        fontWeight="600 !important"
                    >
                        DETAILS
                    </Text>
                </Flex>
                <Grid w="100%" templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"} gridGap="24px">
                    {imgList.map((img) => {
                        return (
                            <CustomCenter
                                key={img.img_URL}
                                background={img ? `url(${img.img_URL}) no-repeat center/cover` : "gray.100"}
                            ></CustomCenter>
                        );
                    })}
                </Grid>
            </Flex>
        </Center>
    );
};
